import { useRef } from "react"
import snarkdown from "snarkdown"

const HTMLText = ({ text, className }) => {
  const ref = useRef(null)

  const processHTML = (html) => {
    // Add target="_blank" only to external links (starting with http or https)
    return html.replace(/<a href="(https?:\/\/[^"]+)"/g, '<a target="_blank" href="$1"')
  }

  return (
    <div className={`${className} markdown`}>
      {text && typeof text === "string" && (
        <span
          ref={ref}
          dangerouslySetInnerHTML={{ __html: processHTML(snarkdown(text)) }}
        />
      )}
    </div>
  )
}

export default HTMLText
